// Do not use this interface in new code. It is deprecated and only used for migrating data.
export enum WidgetSize {
  FullWidth = 2,
  HalfWidth = 1,
}
